const hook = {
  /**
  * 給所有查询添加条件
  * @date: 2020/3/9
  */
  beforeFetch ({ where }) {
    where.isDeleted = false
  },
  /**
  * 给所有增加数据添加条件
  * @date: 2020/3/9
  */
  beforeInsert ({ data }) {
    data.isDeleted = false
  }
}
export default hook
